import { getComponentFromName } from '../../lib/utils';

import * as Components from './age-gates';

function AgeGate({ componentName = null, ...props }: { componentName: string | null }) {
    const Component = getComponentFromName(Components, componentName, 'default') || null;
    return Component !== null ? <Component {...props} /> : null;
}

export default AgeGate;
